import type { ICard } from "../../cardsSlice";

export const major20Card: ICard = {
    id: "major_20",
    arcana: "major",
    number: 20,
    suit: "major",
    court: "major",
    name: "Страшный Суд",
    nameEn: "Judgement",
    keywords: ["Пробуждение", "Ответственность", "Очищение"],
    symbolism: ["Ангел с трубой", "Воскрешающиеся фигуры", "Горы, крест, белое знамя"],
    symbolismInterpretation:
      "Символ духовного пробуждения, очищения, подведения итогов и нового этапа",
    archetype: "Архетип возрождения, пробуждение сознания и призыв к истине",
    psychology: "Готовность услышать внутренний зов, осознание прошлого и ответственности",
    upright: {
      personality: "Пробуждение, внутренний голос, стремление к истине",
      relationships: "Очищение, осознание ошибок, прощение",
      work: "Подведение итогов, результат усилий, вознаграждение",
      spirituality: "Открытие предназначения, переход на новый уровень",
      examples: ["Реализация миссии", "Ответственный выбор", "Воскрешение старых тем"]
    },
    reversed: {
      meaning: "Отрицание ответственности, страх перемен, внутреннее сопротивление",
      nuances: "Промедление, отказ услышать зов"
    },
    associations: ["Возрождение", "Призыв", "Очищение", "Суд"],
    combinations: ["С Смертью — глубокое завершение и новое начало", "С Солнцем — ясность после пробуждения"],
    readingTips: ["Оценить последствия своих действий", "Готовность принять решение"],
    selfQuestions: ["Что мне нужно признать?", "Готов ли я принять свой путь?"]
  };


